/**
	Swap image in Itinerary Slider when slide changes
*/
export const itinerarySliderImageSwap = () => {
	const slider: any = document.querySelector('app-slides.itineraries');
	const imageTarget: any = document.querySelector('.app-itineraries .rotator-image img');

	if (!slider || !imageTarget) {
		return;
	}

	slider.addEventListener('slideSelected', (e) => {
		const current = e.detail;

		if (current && current.getAttribute('data-img')) {
			imageTarget.setAttribute('src', current.getAttribute('data-img'));
		}
		
		if(current && current.getAttribute('data-alt')) {
			imageTarget.setAttribute('alt', current.getAttribute('data-alt'));
		}
	});
};